import React from 'react';
import { Box } from '@mui/material';

import { isLoggedInUserRoot } from '@paragon/login-tools';

import { userToEdit } from '../../selectors/users';
import { useAppSelector } from '../hooks';
import CreateUser from './CreateUser';
import EditUser from './EditUser';
import { UserList } from './UserList';

export function UserDirectory() {
  const user = useAppSelector((state) => userToEdit(state));
  const isRootUser = useAppSelector(isLoggedInUserRoot);

  return user ? (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        flexWrap: { md: 'wrap' },
        justifyContent: 'space-evenly',
        p: { xs: 1, sm: 3 },
      }}
    >
      <UserList />
      <EditUser key={JSON.stringify(user)} />
      {isRootUser ? <CreateUser /> : null}
    </Box>
  ) : null;
}
